import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './CardNewsFullWidth.module.scss';
import Image from '../Image';

const CardNewsFullWidth = ({
    title,
    image,
    text,
    firstPublishedAt,
    href,
    areaCategories,
    filters,
}) => {
    const Tag = !href ? 'div' : 'a';
    let props = {};

    const cardClass = classNames(styles['CardNewsFullWidth'], {
        [styles['CardNewsFullWidth--Link']]: href,
    });

    if (href) {
        props.href = href;
    }

    const allAreasInFilters = filters?.areas.map((area) => area.area);

    const formatedAreaCategories = allAreasInFilters?.every((area) =>
        areaCategories
            .map((area) => area.toLowerCase().trim())
            .includes(area.toLowerCase().trim())
    )
        ? ['Alla områden']
        : areaCategories?.map((area) => area.toLowerCase().trim());

    return (
        <Tag {...props} className={cardClass}>
            <div className={styles['CardNewsFullWidth__Content']}>
                <div className={styles['CardNewsFullWidth__Image']}>
                    <Image maxImageWidth={1020} {...image} altText={''} />
                </div>

                <div className={styles['CardNewsFullWidth__TextContainer']}>
                    {firstPublishedAt && (
                        <div className={styles['CardNewsFullWidth__Meta']}>
                            <span className={styles['CardNewsFullWidth__Date']}>
                                {firstPublishedAt}
                            </span>
                            {formatedAreaCategories.map((category, index) => (
                                <span
                                    key={index}
                                    className={
                                        styles[
                                            'CardNewsFullWidth__AreaCategory'
                                        ]
                                    }
                                >
                                    {category}
                                </span>
                            ))}
                        </div>
                    )}

                    <div className={styles['CardNewsFullWidth__Text']}>
                        <h2 className={styles['CardNewsFullWidth__Title']}>
                            {title}
                        </h2>
                        {text && (
                            <p dangerouslySetInnerHTML={{ __html: text }} />
                        )}
                    </div>
                </div>
                <img
                    src={'/assets/svg/arrow--right-alternative.svg'}
                    alt="Signalisten Logotyp"
                    className={styles['CardNewsFullWidth__Arrow']}
                />
            </div>
        </Tag>
    );
};

CardNewsFullWidth.propTypes = {
    title: PropTypes.string,
    image: PropTypes.object,
    text: PropTypes.string,
    typeTitle: PropTypes.string,
    firstPublishedAt: PropTypes.string,
    href: PropTypes.string,
    type: PropTypes.string,
};

CardNewsFullWidth.defaultProps = {
    title: '',
    image: {},
    text: '',
    typeTitle: '',
    firstPublishedAt: '',
    href: '',
    type: '',
};

export default CardNewsFullWidth;
